import type { ReactElement } from 'react';
import { memo } from 'react';
import { clsx } from 'clsx';
import type { TableHeaderCellProps } from './TableHeaderCell';
import type { TableRowProps } from './TableRow';
import styles from './Table.module.scss';

export interface TableHeaderProps {
    children:
        | ReactElement<TableHeaderCellProps | TableRowProps>
        | ReactElement<TableHeaderCellProps | TableRowProps>[];
    /**
     * Make header stick to top when scrolling
     */
    sticky?: boolean;
    /**
     * Use darker background for header
     */
    dark?: boolean;
}

const TableHeader = ({ children, sticky, dark }: TableHeaderProps) => {
    return (
        <thead
            className={clsx(styles.tableHeader, {
                [styles.sticky]: sticky,
                [styles.dark]: dark,
            })}
        >
            {children}
        </thead>
    );
};

export default memo(TableHeader);
